import {
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider
} from '@material-ui/core';
import React from 'react';
import AllPagesPDFViewer from 'src/components/pdf/all-pages';
import { MobilePDFReader, PDFReader } from 'react-read-pdf';
import { getUser } from 'src/utils/Common';

import manualPDF from './Manual.pdf';
import manualRuPDF from './Manual_RU.pdf';

export default function App() {
  const SessionUser = getUser();
  const samplePDF = SessionUser.IsIhpTenant ? manualRuPDF : manualPDF;

  return (
    <div>
      {/* <AllPagesPDFViewer pdf={samplePDF} /> */}
      <MobilePDFReader url={samplePDF} />
    </div>
  );
}
